// import wx from  'weixin-js-sdk'
export function getWXConfig(dataObj){
  if(typeof wxData === 'undefined') return
  if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    wx.config({
      debug: false,
      appId: wxData.appId, // 必填，公众号的唯一标识
      timestamp: wxData.timestamp, // 必填，生成签名的时间戳
      nonceStr: wxData.nonceStr, // 必填，生成签名的随机串
      signature: wxData.signature,// 必填，签名，sha1加密哈
      jsApiList: ["checkJsApi",'updateTimelineShareData', 'updateAppMessageShareData',"onMenuShareWeibo"] ,// 必填，需要使用的JS接口列表，
      openTagList: ['wx-open-launch-app']
    });
 

  }else{
   
    wx.config({
      debug: false,
      appId: wxData.appId, // 必填，公众号的唯一标识
      timestamp: wxData.timestamp, // 必填，生成签名的时间戳
      nonceStr: wxData.nonceStr, // 必填，生成签名的随机串
      signature: wxData.signature,// 必填，签名，sha1加密哈
      jsApiList: ["checkJsApi", "onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone"],// 必填，需要使用的JS接口列表
      openTagList: ['wx-open-launch-app']
    });

  }
  
  wxshare(dataObj)
}
export function alertInfo(info, cb,time){
  var oAlert = document.createElement('div'),
      timer,
      animationEnd = animationEnd();
  if (document.alertInfoShow) {
    return false;
  }
  document.alertInfoShow = true;
  oAlert.classList.add('alertPop');
  oAlert.style.zIndex = '99999';
  oAlert.innerHTML = '<div class="error"><p>' + info + '</p></div>';
  document.body.appendChild(oAlert);
  oAlert.classList.add('active');
  if (animationEnd) {
    oAlert.addEventListener(animationEnd, function () {
      document.body.removeChild(oAlert);
      cb && cb();
      document.alertInfoShow = false;
    }, false);
  } else {
    clearTimeout(timer);
    timer = setTimeout(function () {
      document.body.removeChild(oAlert);
      cb && cb();
      document.alertInfoShow = false;
    }, time||2000)
  };
  function animationEnd() {
    let style = document.body.style;
    if (typeof style['webkitAnimation'] === 'string') {
      return 'webkitAnimationEnd';
    } else if (typeof style['animation'] === 'string') {
      return 'animationend';
    }
    return '';
  }
};
function wxshare(dataObj) {
  wx.ready(function () {
    console.log('weixinShare-------------')
    var shareData = dataObj;
    var title = shareData.title||document.title;
    var desc = shareData.desc||document.querySelector('meta[name=description]').getAttribute('content');
    var imgUrl = shareData.imgUrl||'https://shop.artplus.com.cn/resource/imgs/weixinImg.png';
    var link = shareData.link||window.location.href; // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    let AFedWxShareData = {
      title:title,
      link:link,
      desc:desc,
      imgUrl:imgUrl,
      success: function (data) { // 用户点击了分享后执行的回调函数
        console.log(222222,data)
      },
      cancel: function () {
        // 用户取消分享后执行的回调函数
        //console.log(222222,data)
      }
    }
    if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
      wx.checkJsApi({
        jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData'], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
          console.log(11111,res)
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        }
      });
      
      wx.updateTimelineShareData(AFedWxShareData);
      wx.updateAppMessageShareData(AFedWxShareData);

    }else{
      wx.checkJsApi({
        jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage", "onMenuShareQQ", "onMenuShareWeibo", "onMenuShareQZone"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function (res) {
          console.log(11111,res)
          // 以键值对的形式返回，可用的api值true，不可用为false
          // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
        }
      });
      
      wx.onMenuShareAppMessage(AFedWxShareData);
      wx.onMenuShareTimeline(AFedWxShareData);
      wx.onMenuShareQQ(AFedWxShareData);
      wx.onMenuShareWeibo(AFedWxShareData);
      wx.onMenuShareQZone(AFedWxShareData);

    }
    
  });
}
// export const AFedWxShareData = {
//   title:'',
//   link:window.location.href,
//   desc:'给自己一个得艺的家',
//   imgUrl:'https://shop.artplus.com.cn/resource/imgs/weixinImg.png',
//   isLoading:2
// }


